import { render } from "./collection-batch.vue?vue&type=template&id=374e1058"
import script from "./collection-batch.vue?vue&type=script&lang=js"
export * from "./collection-batch.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__